import App from '@/models/App'

export default class OrderingOrdererEstimatePriceSummary extends App {
    static get entity() {
        return 'OrderingOrdererEstimatePriceSummaries'
    }

    static all() {
        return this.query().get()
    }

    static fields() {
        return {
            id: this.attr(''),
            orderingEstimateId: this.attr(''),
            currency: this.attr(''),
            finalTotalPrice: this.attr(null),
            createdAt: this.attr(null),
            updatedAt: this.attr(null),
        }
    }

    static apiConfig = {
        actions: {
            create(orderingShipId, orderingOrderId, orderingEstimateId, params) {
                return this.post(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/estimates/${orderingEstimateId}/priceSummaries`,
                    App.post(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(orderingShipId, orderingOrderId, orderingEstimateId, orderingEstimatePriceSummaryId, params) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/estimates/${orderingEstimateId}/priceSummaries/${orderingEstimatePriceSummaryId}`,
                    App.patch(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
